import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'deleteSourceGroup';
export const useDeleteSourceGroupTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Удалить',
    on_success: 'Группа удалена',
    on_error: 'Не удалось удалить группу',
    confirmation: {
      title: 'Удаление группы',
      subtitle: 'Группа будет удалена безвозвратно',
      buttons: {
        cancel: 'Отмена',
        delete: 'Удалить',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Delete',
    on_success: 'Group deleted',
    on_error: 'Failed to delete group',
    confirmation: {
      title: 'Delete group',
      subtitle: 'The group will be permanently deleted',
      buttons: {
        cancel: 'Cancel',
        delete: 'Delete',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Eliminar',
    on_success: 'Grupo eliminado',
    on_error: 'No se pudo eliminar el grupo',
    confirmation: {
      title: 'Eliminar grupo',
      subtitle: 'El grupo se eliminará de forma permanente',
      buttons: {
        cancel: 'Cancelar',
        delete: 'Eliminar',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Excluir',
    on_success: 'Grupo excluído',
    on_error: 'Falha ao excluir grupo',
    confirmation: {
      title: 'Excluir grupo',
      subtitle: 'O grupo será excluído permanentemente',
      buttons: {
        cancel: 'Cancelar',
        delete: 'Excluir',
      },
    },
  },
}) : {}) as Record<string, unknown>;
